var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { IdMenuBalancing } from "../../constants/IdMenuBalancing";
import { MenuWrapper } from "../menus/MenuWrapper";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
var MenuNurseryDOM = /** @class */ (function (_super) {
    __extends(MenuNurseryDOM, _super);
    function MenuNurseryDOM() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenuNurseryDOM.prototype.render = function () {
        var onClose = this.props.onClose;
        return (React.createElement(MenuWrapper, { onClose: onClose, type: IdMenuBalancing.Nursery, modalId: IdModal.Nursery }));
    };
    return MenuNurseryDOM;
}(React.PureComponent));
var mapState = function (state) { return ({}); };
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.Nursery)); },
}); };
export var MenuNursery = connect(mapState, mapDispatch)(MenuNurseryDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/nursery/MenuNursery.tsx
// module id = 2854
// module chunks = 3